import { render, staticRenderFns } from "./onNeig.vue?vue&type=template&id=d11be46c"
import script from "./onNeig.vue?vue&type=script&lang=js"
export * from "./onNeig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports